import { InjectionToken } from "@angular/core";
import { PostLoadHook } from "./PostLoadHook";

export const postLoadHookToken = new InjectionToken<PostLoadHook>("postLoad")
